import HTMLReactParser from "html-react-parser";
import React from "react";
import { MailPost as MailPostType } from "../../../../lib/types";

import avatar from "../../../../assets/images/avatar-temp.png";
import CheckBox from "../../../Common/CheckBox";
import { formatToPostDate } from "../../../../lib/commonFunctions";
import GovernorateInfoLink from "../../../Common/GovernorateInfoLink";
import AllianceInfoLink from "../../../Common/AllianceInfoLink";

interface IProps {
  post: MailPostType,
  toDelete: boolean;
  toggleToDelete: () => void;
  setRecipient: (recipient: string) => void;
}

const MailPost = ({
  post,
  toDelete,
  toggleToDelete,
  setRecipient
}: IProps) => (
  <div className="comment">
    <header className="comment-header clearfix">
      {post.governyB
        ? <>
          <span className="user">
            <img src={avatar} alt="Dragon avatar" className="avatar"/>
            <span className={"comment-info"}>
            <small>{post.sent ? "To:" : "From:"}</small>&nbsp;
            <strong>
              <GovernorateInfoLink
                govId={post.governyB.id}
                name={post.governyB.name}
                raceName={post.governyB.race.name}
              />
            </strong>
            {post.governyB.alliance
              ? <span className="coalition grey">&nbsp;
                (<AllianceInfoLink
                  name={post.governyB.alliance.name}
                  allianceId={post.governyB.alliance.id}
                />)
                </span>
              : <>&nbsp;(Non-alliance)</>
            }
            <small> ({formatToPostDate(new Date(post.postDate.timestamp * 1000))})</small>
            <strong>
              &nbsp;<a href="#account-info-{{ post.governyB.player.id }}" className="disabled">
                {post.governyB.player.name}</a>
            </strong>
            </span>
          </span>
          <span className="pull-right actions hidden-xs">
            {post.governyB.lastAction
            && <small>[online {post.governyB.lastAction}]</small>}
          </span>
        </>
        : <span className="user">
          <img src={avatar} alt="Dragon avatar" className="avatar"/>
          <span className={"comment-info"}>
          <small>From: </small>
          <strong className="gubernate">DRAGESCENT GAME</strong>
          <small> ({formatToPostDate(new Date(post.postDate.timestamp * 1000))})</small>
          </span>
      </span>
      }
    </header>
    <div className="comment-body clearfix">
      <p>{HTMLReactParser(post.content)}</p>
      <div className="row">
        <div className="col-sm-5 col-sm-push-3 col-lg-6 achievements">
          {/* {post.governyB && post.governyB.goldStatus
          && <i className="icon icon-popularita gold"/>} */}
        </div>
        <div className="col-xs-6 col-sm-3 col-sm-pull-5 col-lg-pull-6
        actions admin-actions">
          <CheckBox checked={toDelete} toggle={toggleToDelete} />
          {post.governyB
          && <>
            <a
              className="icon icon-standalone icon-posta item"
              onClick={() => {
                setRecipient(post.governyB.name);
                const contentPopup = document.querySelector("#popup-content");
                if (contentPopup) {
                  contentPopup.scrollTo({ top: 0 })
                }
              }}
            />
          </>}
        </div>
        <div className="col-xs-7 col-sm-4 col-lg-3 actions text-right">
        </div>
      </div>
    </div>
  </div>
)

export default MailPost;
